import React from 'react';
import PolicyAPI from '../../../../redux/incident/api/PolicyAPI';
import { getPolyglot } from '../../../../i18n';
import { useParams } from 'react-router-dom';
import { Skeleton } from '@mui/material';

interface PolicyTitleProps {
  sectionTitle?: string;
}
function PolicyTitle(props: PolicyTitleProps) {
  const { sectionTitle } = props;
  const params = useParams<{
    workspaceId: string;
    policyId: string;
  }>();
  const { data: policy, isLoading } = PolicyAPI.useGetPolicyQuery(params, {
    skip: !params.policyId,
  });

  return (
    <>
      {sectionTitle}
      {isLoading ? (
        <Skeleton width={100} variant="text" />
      ) : (
        policy && ` "${policy?.title}"`
      )}
    </>
  );
}

export default PolicyTitle;
